import api from './apiService';

const getUserById = async (id) => {
  try {
    const response = await api.get(`/users/${id}`, {
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

const userService = {
  getUserById,
};

export default userService; 